import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';

// Import des images
import backgroundHomeImage from '../../assets/images/backgrounds/backgroundHome.png';
import homepageImage from '../../assets/images/illustrations/homepage.png';

const CardComponent = ({
  title = `Enregistrer le <br/> profil d'un enfant`,
  description = ``,
  backgroundImage = backgroundHomeImage,
  childImage = homepageImage,
  backgroundColor = "#784e3c"
}) => {
  return (
    <Box sx={{ position: 'relative', width: '90%', maxWidth: '600px', mt: 5 }}>
      <Card 
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: backgroundColor,
          borderRadius: '25px',
          boxShadow: '0px 4px 10px rgba(44, 164, 191, 0.75)',
          minHeight: '200px',
          position: 'relative',
          overflow: 'visible',
          pr: '10px'
        }}
      >
        {/* Contenu texte */}
        <CardContent 
          sx={{
            p: { xs: 3, sm: 4 },
            textAlign: 'left',
            flex: 1,
            zIndex: 2
          }}
        >
          <Typography 
            variant="h2" 
            component="h1" 
            sx={{
              fontWeight: 'bold',
              mb: 2,
              fontSize: { xs: '1rem', sm: '1.5rem' },
              color: 'white',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              lineHeight: 1.2,
              fontFamily: 'Achiko',
            }}
          >
           Enregistrer le <br/> profil d'un enfant
          </Typography>
          
          <Typography 
            sx={{
              opacity: 0.95,
              lineHeight: 1.6,
              fontSize: { xs: '1rem', sm: '1.25rem' },
              color: 'white',
              textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
              mb: 2,
            }}
          >
          Un programme unique, <br/> taillé pour ses forces et <br/> ses défis
          </Typography>

          <Chip
            label="Nouveau — Profils Neuroatypiques"
            size="small"
            sx={{
              fontWeight: 700,
              bgcolor: '#FFD88C',
              color: '#5a3d2b',
              mb: 0.5,
            }}
          />
          <Typography
            sx={{
              opacity: 0.9,
              lineHeight: 1.5,
              fontSize: { xs: '0.8rem', sm: '0.9rem' },
              color: 'white',
              textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
            }}
          >
            Questionnaire de 15 min pour une Valise VALED adaptée
          </Typography>
        </CardContent>
      

      {/* Image de l'enfant qui déborde */}
      <Box 
        sx={{
          position: 'absolute',
          right: '-20px',
          bottom: '0px',
          zIndex: 3,
          width: { xs: '140px', sm: '180px' },
          height: { xs: '140px', sm: '180px' }
        }}
      >
        <img
          src={childImage}
          alt="Enfant souriant"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.2))'
          }}
          width={140}
          height={140}
        />
      </Box>
      </Card>
    </Box>
  );
};

export default CardComponent;